import { NgModule } from '@angular/core';
import { FbCoreModule } from '@fleet-beat/core';
import { DataAutocompleteTemplatesComponent } from './components/data-autocomplete-templates.component';
import { MatTooltipModule } from '@angular/material/tooltip';

@NgModule({
  imports: [FbCoreModule, MatTooltipModule],
  declarations: [DataAutocompleteTemplatesComponent],
  exports: [DataAutocompleteTemplatesComponent],
})
export class DataAutocompletePresetsModule {}
